import styled from "styled-components";
export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const ModifyForm = styled.div`
  display: flex;
  align-items: center;
`;

export const ModifyBtn = styled.button`
  height: 48px;
  width: 71px;
  height: 47px;
  border: none;
  border-radius: 8px;
  font-family: "SpoqaHanSansNeoRegular";
  font-size: 17px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.orange};
`;

export const Modal = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: absolute;
  width: 364px;
  margin-top: 20px;
  z-index: 999;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MDHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-top: 12px;
`;

export const MDTitle = styled.h1`
  font-size: 16px;
  font-weight: 700;
  color: #5b5555;
`;

export const EscBtn = styled.button`
  position: absolute;
  right: 0;
  margin-right: 5px;
  border: none;
  font-size: 16px;
  background-color: white;
  cursor: pointer;
`;

export const Guidance = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 96px;
  & > p {
    padding: 15px;
    line-height: 18px;
    font-size: 14px;
    color: #b6b3b3;
  }
`;
export const AddressForm = styled.div`
  position: relative;
  display: flex;
  border-bottom: 1px solid #a4b0be;
  width: 100%;
  height: 96px;
  cursor: pointer;
  &:last-of-type {
    border: none;
  }
`;

export const AddressList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  width: 80%;
  height: 100px;
`;

export const RoadName = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-weight: 600;
  width: 100%;
  line-height: 20px;
  color: #5b5555;
`;

export const JibunAddress = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50%;
  margin-bottom: 5px;
  font-size: 0.8rem;
  color: #7d7878;
`;

export const Jibun = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 20px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  margin-right: 5px;
  background-color: #f6f6f6;
  color: #b6b3b3;
`;
export const ZipCode = styled.span`
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

export const ModalFooter = styled.footer`
  width: 100%;
  height: 80%;
  margin-top: 20px;

  background-color: #f6f6f6;
  & > p {
    padding: 15px;
    line-height: 18px;
    font-size: 13px;
    color: #b6b3b3;
  }
`;
